"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isColor = exports.numberBetween = exports.requiredConditionalProp = void 0;
const isNil_1 = __importDefault(require("lodash/isNil"));
const checkPropType = (propType, prop) => {
    switch (propType) {
        case 'number':
            return typeof prop === 'number';
        case 'func':
            return typeof prop === 'function';
        case 'bool':
            return typeof prop === 'boolean';
        case 'string':
            return typeof prop === 'string';
        default:
            return false;
    }
};
const requiredConditionalProp = (propType, requiredProp, expectedValue) => (props, propName, componentName) => {
    const { [requiredProp]: requiredPropValue, [propName]: thisProp } = props;
    if (requiredPropValue
        && ((0, isNil_1.default)(expectedValue) || requiredPropValue === expectedValue)
        && (thisProp === undefined || !checkPropType(propType, thisProp))) {
        return new Error(`${componentName} requires a ${propType} '${propName}' prop if '${requiredProp}' is used`);
    }
    return null;
};
exports.requiredConditionalProp = requiredConditionalProp;
const numberBetween = (min, max) => (props, propName) => {
    const { [propName]: prop } = props;
    if (typeof prop !== 'number' || prop < min || prop > max) {
        return new Error(`Prop ${propName} must be a number between ${min} and ${max}`);
    }
    return null;
};
exports.numberBetween = numberBetween;
const isColor = (props, propName) => {
    const { [propName]: propColor } = props;
    const { style } = new Option();
    style.color = propColor;
    if (style.color.length === 0) {
        return new Error(`Prop ${propName} must be a valid color`);
    }
    return null;
};
exports.isColor = isColor;
//# sourceMappingURL=prop-types-utils.js.map